<template>
    <div class="text-4xl mb-16 text-fau-blue-bright">
        Something went wrong...
    </div>
    <div class="text-2xl mb-16 text-fau-blue-bright">Press Try Again</div>
    <div class="flex items-center gap-x-5 text-fau-blue">
        <button
            class="bg-fau-blue-bright text-white p-5"
            ref="button"
            type="button"
            href="#"
            v-on:click.prevent="submit"
        >
            <span>Press to Submit</span>
        </button>
        <template v-if="!isMobile">
            <div class="border border-black w-10 h-0"></div>
            <a href="#" v-on:click.prevent="submit"> Press Enter</a>
        </template>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    submit: () => void;
    isMobile: boolean;
}>();
</script>
